var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { forwardRef, useState } from 'react';
import { useUncontrolledProp } from 'uncontrollable';
import { MODE, SIZE } from '../../constants';
import { getVisualStateAttributes } from '../../utils';
import styles from './styles.module.css';
export const TogglePrivate = forwardRef(function TogglePrivate(_a, ref) {
    var { render, checked: checkedProp, defaultChecked, onChange, onBlur, onFocus, disabled, className, size = SIZE.M, mode = MODE.Checkbox, onKeyUp, 'data-test-id': testId } = _a, otherProps = __rest(_a, ["render", "checked", "defaultChecked", "onChange", "onBlur", "onFocus", "disabled", "className", "size", "mode", "onKeyUp", 'data-test-id']);
    const [checked, setChecked] = useUncontrolledProp(checkedProp, Boolean(defaultChecked), onChange);
    const [focusVisible, setFocusVisible] = useState(false);
    const [hover, setHover] = useState(false);
    const visualState = {
        disabled: Boolean(disabled),
        focusVisible,
        checked,
        hover,
        size,
    };
    return (_jsxs("span", Object.assign({ role: mode, className: cn(className, styles.toggleLayout), "data-size": size, "data-test-id": testId, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), onKeyUp: onKeyUp }, getVisualStateAttributes(visualState), { children: [render(visualState), _jsx("input", Object.assign({}, otherProps, { "data-test-id": `${testId}-native-input`, ref: ref, type: mode, className: styles.togglePrivate, checked: checked, disabled: disabled, onChange: e => setChecked(e.target.checked), onFocus: event => {
                    setFocusVisible(event.target.matches(':focus-visible'));
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                }, onBlur: event => {
                    setFocusVisible(false);
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                } }))] })));
});
